import React, { FC } from "react";

import { useBasketShare } from "@keepeek/commons";
import { KModalContentSection, withSuspense } from "@keepeek/refront-components";
import { Checkbox, FormControlLabel, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { configSectionComponentBasketSelector } from "../../../providers/config/selectors";

import { CommonBasketShareProps } from "./index";

const labelId = "PublicShareAccessCode-input-label";

const PublicShareAccessCode: FC<CommonBasketShareProps> = function ({
  basketId,
  sentryCallback,
  snackbarCallback,
}) {
  const { t } = useTranslation();
  const { displayBackofficeSharedBasket } = useRecoilValue(
    configSectionComponentBasketSelector,
  ) ?? {
    displayBackofficeSharedBasket: undefined,
  };
  const { selectedAccessCode, setSelectedAccessCode } = useBasketShare(
    displayBackofficeSharedBasket ?? false,
    basketId,
    sentryCallback,
    snackbarCallback,
  );
  return (
    <KModalContentSection
      title={<span id={labelId}>{t("basket.share.content.access-code.title")}</span>}
      description={t("basket.share.content.access-code.description")}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={selectedAccessCode.active}
            onChange={(e) =>
              setSelectedAccessCode((currVal) => ({ ...currVal, active: e.target.checked }))
            }
          />
        }
        label={t("basket.share.content.access-code.checkbox.label").toString()}
      />
      <TextField
        id="PublicShareAccessCodeInput"
        inputProps={{ "aria-labelledby": labelId }}
        type="text"
        defaultValue={selectedAccessCode.code}
        value={selectedAccessCode.code}
        onChange={(e) =>
          setSelectedAccessCode((currVal) => ({
            ...currVal,
            active: e.target.value.length > 0,
            code: e.target.value,
          }))
        }
        variant="standard"
        sx={{ "& input": { padding: "9px 0px 0px" } }}
      />
    </KModalContentSection>
  );
};

export default withSuspense(PublicShareAccessCode);
